import styles from './HomepageIcons.module.css';

export const DashboardsIcon = () => (
  <div className={styles.icon}>
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.48485 23.7V14.8757H1.01819V23.7H8.48485ZM8.48485 23.7H15.9515M8.48485 23.7V1.29999H15.9515V23.7M15.9515 23.7H23.4182V8.08787H15.9515V23.7Z"
        stroke="currentColor"
        strokeWidth="2.03636"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

export const DiscoveryIcon = () => (
  <div className={styles.icon}>
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.914 14.9785C28.914 22.6748 22.6748 28.914 14.9785 28.914C7.28213 28.914 1.043 22.6748 1.043 14.9785C1.043 7.28213 7.28213 1.043 14.9785 1.043C22.6748 1.043 28.914 7.28213 28.914 14.9785Z"
        stroke="currentColor"
        strokeWidth="2.08598"
      />
      <path
        d="M21.2078 7.99634L11.966 11.9654L8.7211 21.9317L17.9921 17.9915L21.2078 7.99634Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2.08598"
      />
      <circle
        className={styles.alternateFill}
        cx="14.9759"
        cy="14.9788"
        r="2.7813"
      />
    </svg>
  </div>
);

export const ToolsIcon = () => (
  <div className={styles.icon}>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.99408 0.99408H11.1759V11.1759H0.99408V0.99408Z"
        stroke="currentColor"
        strokeWidth="1.98817"
        strokeLinecap="round"
      />
      <path
        d="M16.6584 0.99408H26.8402V11.1759H16.6584V0.99408Z"
        stroke="currentColor"
        strokeWidth="1.98817"
        strokeLinecap="round"
      />
      <path
        d="M0.99408 16.6584H11.1759V26.8402H0.99408V16.6584Z"
        stroke="currentColor"
        strokeWidth="1.98817"
        strokeLinecap="round"
      />
      <path
        d="M16.6584 21.7493C16.6584 18.9377 18.9377 16.6584 21.7493 16.6584C24.561 16.6584 26.8402 18.9377 26.8402 21.7493C26.8402 24.561 24.561 26.8402 21.7493 26.8402C18.9377 26.8402 16.6584 24.561 16.6584 21.7493Z"
        stroke="currentColor"
        strokeWidth="1.98817"
        strokeLinecap="round"
      />
    </svg>
  </div>
);

export const ReportsIcon = () => (
  <div className={styles.icon}>
    <svg
      width="28"
      height="24"
      viewBox="0 0 28 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.43136"
        y="4.8569"
        width="22.1366"
        height="18.2857"
        stroke="currentColor"
        strokeWidth="1.71429"
      />
      <rect
        x="0.857143"
        y="0.857143"
        width="22.1366"
        height="18.2857"
        className={styles.alternateFill}
        stroke="currentColor"
        strokeWidth="1.71429"
      />
      <path
        d="M5.14453 15.4287L9.71596 11.4287L12.5731 14.8572L18.8588 8.57153"
        stroke="currentColor"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="5.42746"
        y1="4.85721"
        x2="11.7132"
        y2="4.85721"
        stroke="currentColor"
        strokeWidth="1.71429"
        strokeLinecap="round"
      />
    </svg>
  </div>
);

export const DataIcon = () => (
  <div className={styles.icon}>
    <svg
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9868 9.69381L6.22888 3.49005"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3659 17.5821V8.01953C22.3654 7.60029 22.2549 7.18855 22.045 6.82559C21.8352 6.46263 21.5336 6.16123 21.1706 5.95161L12.8033 1.17029C12.4399 0.960467 12.0276 0.850006 11.6079 0.850006C11.1883 0.850006 10.776 0.960467 10.4126 1.17029L2.04531 5.95161C1.68224 6.16123 1.38068 6.46263 1.17087 6.82559C0.96107 7.18855 0.850406 7.60029 0.849976 8.01953V17.5821C0.850406 18.0014 0.96107 18.4131 1.17087 18.7761C1.38068 19.139 1.68224 19.4405 2.04531 19.65L10.4126 24.4313C10.776 24.6412 11.1883 24.7517 11.6079 24.7517C12.0276 24.7517 12.4399 24.6412 12.8033 24.4313L21.1706 19.65C21.5336 19.4405 21.8352 19.139 22.045 18.7761C22.2549 18.4131 22.3654 18.0014 22.3659 17.5821Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.172 6.77631L11.6072 12.8127L22.0424 6.77631"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6079 24.8503V12.8014"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6881 9.81479V13.4008"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
